<script lang="ts">
  /* TermsGate — the blocking dialog an account without terms_accepted_at meets
     right after login: accounts we created by hand, invitees from before the
     signup checkbox. Nothing behind it is reachable until «I agree»; there is
     no close button on purpose. The documents open in a new tab. */
  import { _ } from "svelte-i18n";
  import { acceptTerms, logout } from "$lib/auth";
  import ConsentText from "./ConsentText.svelte";

  let checked = $state(false);
  let saving = $state(false);
  let error = $state("");

  async function agree() {
    if (!checked) return;
    saving = true;
    error = "";
    try {
      await acceptTerms();
    } catch {
      error = $_("consent.gate.error");
    } finally {
      saving = false;
    }
  }
</script>

<div class="gate-backdrop" role="presentation">
  <div class="gate" role="dialog" aria-modal="true" aria-labelledby="terms-gate-title" tabindex="-1">
    <div class="gate-head">
      <span class="material-icons-outlined gate-icon" aria-hidden="true">policy</span>
      <h2 id="terms-gate-title">{$_("consent.gate.title")}</h2>
    </div>
    <p class="gate-intro">{$_("consent.gate.intro")}</p>
    <label class="gate-check">
      <input type="checkbox" bind:checked disabled={saving} />
      <ConsentText />
    </label>
    {#if error}<p class="gate-error" role="alert">{error}</p>{/if}
    <div class="gate-actions">
      <button type="button" class="btn btn--ghost" onclick={() => logout()} disabled={saving}>{$_("shell.logout")}</button>
      <button type="button" class="btn btn--primary" onclick={agree} disabled={!checked || saving}>
        {saving ? $_("common.saving") : $_("consent.gate.button")}
      </button>
    </div>
  </div>
</div>

<style>
  .gate-backdrop {
    position: fixed; inset: 0; z-index: 3000; background: rgba(48, 56, 65, 0.72);
    display: flex; align-items: center; justify-content: center; padding: 20px;
  }
  .gate {
    background: var(--color-card); border-radius: 10px; width: 100%; max-width: 540px;
    box-shadow: 0 24px 72px rgba(0,0,0,0.3); padding: 24px 28px;
    display: flex; flex-direction: column; gap: 14px; color: var(--color-text);
  }
  .gate-head { display: flex; align-items: center; gap: 12px; }
  .gate-icon { font-size: 30px !important; color: var(--color-primary); }
  .gate h2 { margin: 0; font-size: 18px; }
  .gate-intro { margin: 0; font-size: 14px; color: var(--color-text-muted); line-height: 1.5; }
  .gate-check { display: flex; gap: 10px; align-items: flex-start; font-size: 14px; line-height: 1.5; cursor: pointer; }
  .gate-check input { margin-top: 3px; flex-shrink: 0; }
  .gate-error { margin: 0; font-size: 13px; color: var(--color-danger); }
  .gate-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 4px; }
</style>
